import { XIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface ResetFilterButtonProps {
  onClick: VoidFunction
}

export const ResetFilterButton = ({ onClick }: ResetFilterButtonProps) => {
  return (
    <Button type="button" className={cn('flex items-center gap-2 px-4')} variant="ghost" size="sm" onClick={onClick}>
      Reset
      <XIcon size={16} />
    </Button>
  )
}
